var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.path)?_c('div',{staticClass:"audio_explain flex-col"},[_c('div',{staticClass:"audio_content flex-center"},[_c('audio',{attrs:{"src":_vm.path,"controls":""}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }